module.exports = __webpack_public_path__ + "static/Andrew-ccf26b3900827ad6b36cdd9764e5c3cf.jpg";